/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.8.13",
    versionName: "0.2.0-nightly.2025.8.13",
    versionChannel: "nightly",
    buildDate: "2025-08-13T00:09:45.582Z",
    commitHash: "3516d45db18a72a4323390dcda82c84e3004288b",
};
